export default "__VITE_ASSET__DkOZA1Ov__"